import React, {useMemo, useState} from 'react';
import styled, {useTheme} from "styled-components";
import useEventAPI from "../../common/hooks/useEventAPI";
import {useSelector} from "react-redux";
import EventPlayerList from "./EventPlayerList";
import EventChart from "./EventChart";
import {useTranslation} from "react-i18next";
import EventComment from "./EventComment";

const Wrapper = styled.div`
  width: 100%;
`;
const BannerWrapper = styled.div`
  margin-bottom: 14px;
`;
const TitleText = styled.span`
  font-size: 28px;
  color: ${props => props.theme.color.dark_100};
  font-weight: 700;
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-top: 14px;
`;
const setInitialRegion = (region, eventRegionList) => {
    const firstEvent = eventRegionList[0];
    const has = eventRegionList.includes(region);
    if (has) {
        return region
    }
    const hasKor = eventRegionList.includes('KR');
    if (hasKor) {
        return 'KR'
    }
    return firstEvent
}

const ListWrapper = styled.div`
  & + & {
    margin-top: 20px;
  }
`;
const EventContent = () => {
    const {t} = useTranslation()
    const theme = useTheme();
    const {eventQuery} = useEventAPI();
    const region = useSelector((state) => state.region.result);
    const currentLang = useSelector((state) => state.translation.lang);
    const [selectedRegion, setSelectedRegion] = useState(setInitialRegion(region, eventQuery.data.eventRegionList));
    const [selectedType, setSelectedType] = useState(eventQuery.data.eventFilter[0]);


    const list = useMemo(() => {
        try {
            const eventList = eventQuery.data.list;
            // const region = getRegion(selectedRegion);
            // const regionFilteredObj = eventList.find((data) => data.platform_id === region);
            // if (selectedType === 'STRM') {
            //     return Object.values(regionFilteredObj.streamer)
            // }
            // const result = regionFilteredObj[selectedType?.toLowerCase()]
            // return Object.values(result)
            return eventList;
        } catch (e) {
            return [];
        }
    }, [eventQuery.data.list, selectedRegion, selectedType])


    const currentTierOff = useMemo(() => {
        try {
            const normalizedData = eventQuery.data.normalizeData
            const findData = eventQuery.data.tier_cut_map.find((data) => data.platform_id === selectedRegion);
            const challengerFilter = normalizedData.filter((data) => data.tier === 'CHALLENGER');
            const grandmasterFilter = normalizedData.filter((data) => data.tier === 'GRANDMASTER');
            const masterFilter = normalizedData.filter((data) => data.tier === 'MASTER');

            const masterList = masterFilter.map((data) => data.lp);
            const grandMasterList = grandmasterFilter.map((data) => data.lp);
            const challengerList = challengerFilter.map((data) => data.lp);


            const masterMax = Math.max(...masterList)
            const grandMasterMax = Math.max(...grandMasterList)
            const challengerMax = Math.max(...challengerList)


            if (findData) {
                return {
                    challenger_1st: challengerMax > findData.challenger_1st ? challengerMax : findData.challenger_1st,
                    challenger_cut_off: grandMasterMax > findData.challenger_cut_off ? grandMasterMax : findData.challenger_cut_off,
                    grandmaster_cut_off: masterMax > findData.grandmaster_cut_off ? masterMax : findData.grandmaster_cut_off,
                }
            }
            return {
                challenger_1st: challengerMax,
                challenger_cut_off: grandMasterMax,
                grandmaster_cut_off: masterMax,
            }
        } catch (e) {
            console.log(e)
            return eventQuery?.data.tier_cut_map?.[0]
        }
    }, [eventQuery.data.list, selectedRegion, list]);

    if (list.length === 0) {
        return (
            <Wrapper>
                <GreenBox/>
            </Wrapper>
        )
    }
    return (
        <Wrapper>
            <GreenBox/>
            {/*<BannerWrapper>*/}
            {/*    <TitleText>{t('event.title')}</TitleText>*/}
            {/*</BannerWrapper>*/}
            {/*<EventFilter*/}
            {/*    regionList={eventQuery.data.eventRegionList}*/}
            {/*    typeList={eventQuery.data.eventFilter}*/}
            {/*    selectedRegion={selectedRegion}*/}
            {/*    setSelectedRegion={setSelectedRegion}*/}
            {/*    selectedType={selectedType}*/}
            {/*    setSelectedType={setSelectedType}/>*/}
            {list.map((item, index) => {
                const leader = eventQuery.data.commentList[index];
                return (
                    <ListWrapper>
                        <EventComment team={leader.team_full} cheer={leader.comment}/>
                        <CardWrapper>
                            <EventPlayerList data={item} room={false}/>
                        </CardWrapper>
                        <EventChart list={item}
                                    tierOff={currentTierOff}/>
                    </ListWrapper>
                )
            })}
            {/*<BannerWrapper>*/}
            {/*    <img src={`images/event/event_banner_${getBannerName()}.svg`} width={1080} height={52} alt={''}/>*/}
            {/*</BannerWrapper>*/}
            {/*<EventScrimTable teamArray={eventQuery.data.eventArray} scrim={eventQuery.data.scrim}/>*/}
            {/*{eventQuery.data.eventArray.map((data, index) => {*/}
            {/*    return (*/}
            {/*        <EventBox key={index}>*/}
            {/*        </EventBox>*/}
            {/*    )*/}
            {/*})}*/}
            {/*<EventInfo list={eventQuery.data.playerArray} aiList={eventQuery.data.aiScoreArray}/>*/}
        </Wrapper>
    );
};

const EventFilterWrapper = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.site_main_color};
`;

const RegionBox = styled.div`
  display: flex;
  flex-direction: row;

  & + & {
    margin-top: 10px;
  }
`;

const FilterButton = styled.button`
  font-size: 12px;
  font-weight: 500;
  color: ${props => props.theme.color.dark_200};
  display: flex;
  flex-direction: row;
  min-width: 100px;
  justify-content: center;
  align-items: center;
  height: 26px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  margin-inline: -1px;
  background-color: ${props => props.theme.color.site_main_color};

  &:first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }

  &.selected {
    border-color: ${props => props.selectedBorderColor || props.theme.color.green_100};
    background-color: ${props => props.selectedColor || props.theme.color.green_200};
    color: ${props => props.selectedFontColor || props.theme.color.green_100};
    font-weight: 700;
    z-index: 2;
  }
`;
const EventFilter = ({selectedRegion, setSelectedType, regionList, selectedType, setSelectedRegion, typeList}) => {
    const theme = useTheme();

    const getTypeBackgroundColor = (type) => {
        switch (type) {
            case 'All':
                return "";
            case 'PRO':
                return theme.color.purple_400;
            case 'STRM' :
                return theme.color.red_700;
            default:
                return ""
        }
    }
    const getTypeFontColor = (type) => {
        switch (type) {
            case 'All':
                return "";
            case 'PRO':
                return '#8775FB';
            case 'STRM' :
                return '#EE6787';
            default:
                return ""
        }
    }


    const getTypeBorderColor = (type) => {
        switch (type) {
            case 'All':
                return "";
            case 'PRO':
                return '#8775FB';
            case 'STRM' :
                return '#EE6787';
            default:
                return ""
        }
    }
    return (
        <EventFilterWrapper>
            <RegionBox>
                {regionList.map((data) => {
                    return (
                        <FilterButton className={data === selectedRegion ? 'selected' : ""}
                                      key={data} onClick={() => setSelectedRegion(data)}>{data}</FilterButton>
                    )
                })}
            </RegionBox>
            <RegionBox>
                {typeList.map((data) => {
                    return (
                        <FilterButton className={data === selectedType ? 'selected' : ""}
                                      key={data}
                                      selectedColor={getTypeBackgroundColor(data)}
                                      selectedFontColor={getTypeFontColor(data)}
                                      selectedBorderColor={getTypeBorderColor(data)}
                                      onClick={() => setSelectedType(data)}
                        >{data}</FilterButton>
                    )
                })}
            </RegionBox>
        </EventFilterWrapper>
    )
}

const GreenBoxWrapper = styled.div`
  margin: 10px 0 20px;
  border: 2px solid ${props => props.theme.color.green_100};
  background-color: ${props => props.theme.color.green_200};
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 96px;
  color: ${props => props.theme.color.green_100};
  font-weight: bold;
  font-size: 20px;
`;

const GreenBox = () => {
    const {t} = useTranslation()
    return (
        <GreenBoxWrapper>
            {t('gemagema.banner')}
        </GreenBoxWrapper>
    )
}
export default EventContent;